


















import Material, { MATERIAL_STATUS } from "@/model/material";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import materialApi from "@/api/materialApi";
@Component({
  name: "qMaterialSelect",
  components: {},
  directives: {},
})
export default class QMaterialSelect extends Vue {
  public materials: Material[] = [];
  public selected = "";
  @Prop()
  faceId: string;
  @Prop()
  value;
  @Prop({
    default: () => {
      return [];
    },
  })
  overrideClass: [];
  defaultClass = ["mb__form-select", "mb__m-right-xs"];

  @Watch("value")
  updateValue() {
    this.selected = this.value;
  }

  @Watch("faceId")
  changeCompanyId(newValue) {
    if (newValue) {
      this.getList();
    } else {
      this.materials = [];
    }
  }
  
  mounted() {
    if (this.faceId) {
      this.getList();
    }
    this.selected = this.value;
    if (this.overrideClass.length > 0) {
      this.defaultClass = this.overrideClass;
    }
  }

  public changed($event) {
    this.$emit("input", $event.target.value);
    this.$emit(
      "change",
      $event.target.value
        ? this.materials.find((item) => item.id === $event.target.value)
        : null
    );
  }

  public async getList() {
    const result = await materialApi.index({
      face_id: this.faceId,
      status: MATERIAL_STATUS.MATERIAL_STATUS_ACTIVE
    });
    if (result) {
      this.materials = result;
    }
  }
}
